import { create } from 'zustand';

export type Sport = 'wc' | 'ncaa';

interface SportStore {
  activeSport: Sport;
  setSport: (sport: Sport) => void;
}

function getInitialSport(): Sport {
  try {
    const saved = localStorage.getItem('bb-preferred-sport');
    if (saved === 'wc' || saved === 'ncaa') return saved;
  } catch {}
  return 'wc';
}

export const useSportStore = create<SportStore>((set) => ({
  activeSport: getInitialSport(),
  setSport: (sport) => {
    try { localStorage.setItem('bb-preferred-sport', sport); } catch {}
    set({ activeSport: sport });
  },
}));
